// feat_148 — ServiciosIA: catálogo CERRADO de modelos por proveedor CON
// modalidades. Separado de llmModels.js (que usa MatchProp y NO se toca).
//
// Cada modelo declara las modalidades que soporta. El PRIMERO de cada
// (proveedor, modalidad) es el default sugerido. Debe coincidir con los
// defaults del backend (capabilities.ts defaultModelFor).
//
// AGREGAR un modelo = una línea en este mapa.

export const AI_MODELS = {
  openai: [
    { id: "gpt-4o-mini", modalities: ["complete", "vision"] },
    { id: "whisper-1", modalities: ["transcribe"] },
    { id: "gpt-4o-transcribe", modalities: ["transcribe"] },
    { id: "gpt-4o", modalities: ["complete", "vision"] },
  ],
  anthropic: [
    { id: "claude-haiku-4-5-20251001", modalities: ["complete", "vision"] },
    { id: "claude-sonnet-4-6", modalities: ["complete", "vision"] },
  ],
  gemini: [
    { id: "gemini-2.5-flash-lite", modalities: ["complete", "transcribe", "vision"] },
    { id: "gemini-2.5-flash", modalities: ["complete", "transcribe", "vision"] },
  ],
};

// Proveedores que soportan una modalidad dada (espejo de PROVIDER_MODALITIES
// del backend). Útil para filtrar el selector de proveedor por servicio.
export const providersForModality = (modality) =>
  Object.keys(AI_MODELS).filter((p) =>
    (AI_MODELS[p] || []).some((m) => m.modalities.includes(modality))
  );

export const providerSupports = (provider, modality) =>
  (AI_MODELS[(provider || "").toLowerCase()] || []).some((m) =>
    m.modalities.includes(modality)
  );

// Lista de ids de modelo para (proveedor, modalidad).
export const modelsForProvider = (provider, modality) =>
  (AI_MODELS[(provider || "").toLowerCase()] || [])
    .filter((m) => !modality || m.modalities.includes(modality))
    .map((m) => m.id);

export const defaultModelFor = (provider, modality) => {
  const list = modelsForProvider(provider, modality);
  return list.length > 0 ? list[0] : "";
};

export default AI_MODELS;
